import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const footerIcons = ['🌟', '🦋', '🌈', '💖', '🌸'];

  return (
    <footer className="footer">
      <div className="container">
        <motion.div
          className="footer-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <motion.p
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            Made with 💖 for the amazing Krisha
          </motion.p>
          
          <div className="footer-icons">
            {footerIcons.map((icon, index) => (
              <motion.span
                key={index}
                className="footer-icon dance"
                whileHover={{ 
                  scale: 1.3, 
                  rotate: 360,
                  y: -10
                }}
                transition={{ 
                  duration: 0.5,
                  delay: index * 0.1
                }}
                style={{
                  animationDelay: `${index * 0.2}s`
                }}
              >
                {icon}
              </motion.span>
            ))}
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
